import classNames from 'classnames';

import { useMainMachine } from '../../../utils/useMainMachine';
import { DeviceSwitcher } from './DeviceSwitcher';
import { Generate } from './Generate';
import { UndoRedo } from './UndoRedo';
import { DEVICES } from '../../constants';
import { SaveButton } from './SaveButton';
import { VoiceSelector } from './VoiceSelector';
import { WordsChanged } from './WordsChanged';
import { InteractiveModeButton } from './InteractiveModeButton';
import { SegmentSelector } from './SegmentSelector';
import { BrandGuidelines } from './BrandGuidelines';

export function TopBar() {
  const { useSelector } = useMainMachine();
  const device = useSelector(({ context }) => context.device);

  const isMobile = device === DEVICES.MOBILE;

  return (
    <div className="contents" data-testid="topbar">
      <>
        <div
          className={classNames(
            'h-[70px] shrink-0 grow-0 pt-[30px] pb-[10px] items-center w-full justify-between space-x-2.5',
            {
              'hidden 2xl:flex': !isMobile,
              'hidden ': isMobile,
            },
          )}
        >
          <div className="flex items-center space-x-5">
            <SegmentSelector />
            <DeviceSwitcher />
          </div>
          <div className="flex items-center space-x-5">
            <InteractiveModeButton />
            <div className="flex items-center space-x-2.5">
              <VoiceSelector />
              <Generate />
            </div>
            <BrandGuidelines />
          </div>
          <div className="flex items-center">
            <UndoRedo />
            <WordsChanged />
            <SaveButton />
          </div>
        </div>

        <>
          <div
            className={classNames(
              'h-[70px] shrink-0 grow-0 pt-[30px] pb-[10px] items-center w-full justify-center space-x-5',
              {
                'flex 2xl:hidden': !isMobile,
                'flex ': isMobile,
              },
            )}
          >
            <div className="flex items-center space-x-2.5">
              <VoiceSelector />
              <Generate />
            </div>
            <BrandGuidelines />
            <div className="flex items-center ml-5">
              <UndoRedo />
              <WordsChanged />
              <SaveButton />
            </div>
          </div>
          <div
            className={classNames('h-[45px] pt-1.25 pb-2.5 justify-center w-full space-x-5', {
              'flex 2xl:hidden': !isMobile,
              'flex ': isMobile,
            })}
          >
            <SegmentSelector />
            <DeviceSwitcher />
            <InteractiveModeButton />
          </div>
        </>
      </>
    </div>
  );
}
